import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { withDashboardFilters } from '../../utils/dashboardNav';

export function SettingsBtn({ to }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  return (
    <button
      type="button"
      className="appbar-icon"
      aria-label="設定"
      onClick={() => navigate(withDashboardFilters(to || '/settings', searchParams))}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" stroke="var(--slate)" strokeWidth="2" />
        <path
          d="M19 12a7 7 0 00-.1-1l2-1.5-2-3.5-2.3 1a7 7 0 00-1.7-1l-.4-2.5h-4l-.4 2.5a7 7 0 00-1.7 1l-2.3-1-2 3.5L5 11a7 7 0 000 2l-2 1.5 2 3.5 2.3-1a7 7 0 001.7 1l.4 2.5h4l.4-2.5a7 7 0 001.7-1l2.3 1 2-3.5-2-1.5a7 7 0 00.1-1z"
          stroke="var(--slate)"
          strokeWidth="1.4"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

export function HomeBar({ name, settingsPath }) {
  return (
    <header className="appbar appbar--plain">
      <div className="appbar-row">
        {/* Same title style as the other tabs; 「様」 kept as a lighter suffix */}
        <div className="appbar-title">
          {name}
          <span className="appbar-title-suffix"> 様</span>
        </div>
        <SettingsBtn to={settingsPath} />
      </div>
    </header>
  );
}

export function NavBar({ title, backLabel, backTo, onBack, settingsPath, hideSettings }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const handleBack = () => {
    if (onBack) onBack();
    else navigate(withDashboardFilters(backTo || '/', searchParams));
  };
  return (
    <header className="appbar appbar--plain">
      <div className="appbar-row">
        <button
          type="button"
          className="appbar-back"
          onClick={handleBack}
          style={{ flex: '0 0 auto', justifyContent: 'flex-start' }}
        >
          <svg viewBox="0 0 9 14" fill="none" aria-hidden="true">
            <path d="M7 1L2 7l5 6" stroke="var(--slate)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          {backLabel}
        </button>
        <div className="appbar-center">{title}</div>
        <div style={{ flex: '0 0 auto', display: 'flex', justifyContent: 'flex-end' }}>
          {!hideSettings && <SettingsBtn to={settingsPath} />}
        </div>
      </div>
    </header>
  );
}
